import { useCallback } from 'react';
import { useNativeEvent } from './useNativeEvent';
import { useLaboratorySetting } from './useLaboratorySetting';

type Params = {
  instanceId: string;
  onCapture: () => void;
};

export const useScreenshot = ({ instanceId, onCapture }: Params) => {
  const { isOn: isScreenShotShareOn } = useLaboratorySetting(
    'IS_SELECT_GOODS_SCREEN_SHOT_SHARE',
  );

  const handleScreenshot = useCallback(() => {
    if (!isScreenShotShareOn) return;
    onCapture();
  }, [isScreenShotShareOn, onCapture]);

  useNativeEvent('screenshot', instanceId, handleScreenshot);
};
